import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { PostgradTrialState } from './state';
import { PostgradTrialStatus, PostgradTrial } from '@/models/postgradTrial/PostgradTrialModel';
import { getDiffTime } from '@/helpers/date';

const getters: GetterTree<PostgradTrialState, RootState> = {
  trialByDescomplicaCourseId:
    (state) =>
    (chimeraCourseId: string): PostgradTrial | null => {
      if (!chimeraCourseId) return null;

      const trial = state.trialByDescomplicaCourseId[chimeraCourseId];

      return trial;
    },
  getTrialStatusByDescomplicaCourseId:
    (state) =>
    (chimeraCourseId: string): PostgradTrialStatus | null => {
      if (!chimeraCourseId) return null;

      const trial = state.trialByDescomplicaCourseId[chimeraCourseId];

      if (!trial) return { is_trial: !!trial };

      const currentDate = new Date();

      const { days } = getDiffTime(trial.expirationDate, currentDate);

      return { is_trial: !!trial, days_remaining: days };
    },
};

export default getters;
